// Gatsby requirements
import React from "react"

// Storyblok Components
import Section from "components/Section/Section"
import Faq from "components/Faq/Faq"
import Topics from "components/Topics/Topics"
import FeaturedArticle from "components/FeaturedArticle/FeaturedArticle"
import ListOfArticles from "components/ListOfArticles/ListOfArticles"
import TimelineCards from "components/TimelineCards/TimelineCards"
import ContentCards from "components/ContentCards/ContentCards"
import Staff from "components/Staff/Staff"
import PricingCards from "components/PricingCards/PricingCards"
import Html from "components/Html/Html"
import PricingTable from "components/PricingTable/PricingTable"
import Reviews from "components/Reviews/Reviews"
import ID from "components/ID/ID"

const StoryblokComponents = ({ content }) => (

    content?.map((blok) => {
        switch (blok.component) {
            case 'Section': return <Section key={blok._uid} data={blok} />
            case 'Section: Faq': return <Faq key={blok._uid} data={blok} />
            case 'Section: Blog Topics': return <Topics key={blok._uid} data={blok} />
            case 'Section: Featured Article': return <FeaturedArticle key={blok._uid} data={blok} />
            case 'Section: Timeline Cards': return <TimelineCards key={blok._uid} data={blok} />
            case 'Section: Content Cards': return <ContentCards key={blok._uid} data={blok} />
            case 'Section: Staff': return <Staff key={blok._uid} data={blok} />
            case 'Section: Pricing Cards': return <PricingCards key={blok._uid} data={blok} />
            case 'Section: HTML': return <Html key={blok._uid} data={blok} />
            case 'Section: Pricing Table': return <PricingTable key={blok._uid} data={blok} />
            case 'Section: Reviews': return <Reviews key={blok._uid} data={blok} />
            case 'Section: List of Articles': return <ListOfArticles key={blok._uid} data={blok} />
            case 'Section: ID Anchor': return <ID key={blok._uid} data={blok} />
        }
    })
)

export default StoryblokComponents
